import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[myNumberOnly]'
})
export class NumberOnlyDirective {
    private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        if (event.key == "v" &&  event.ctrlKey ) {
            navigator.clipboard.readText().then(async (clipboardContents) => {
                for (const item of await clipboardContents) {
                    if (!String(item).match(this.regex)) {
                        event.preventDefault();
                    }
                  }
            });
        } else {
            let current: string = this.el.nativeElement.value;
            let next: string = current.concat(event.key);
            if (next && !String(next).match(this.regex)) {
                event.preventDefault();
           }
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        let current: string = event.clipboardData.getData('text/plain');
        if (!String(current).match(this.regex)) {
            event.preventDefault();
       }       
    }
}